import { DoorOpen } from 'lucide-react'

import { FollowUserButton } from '../FollowUserButton'

import { useModalContext } from '@/shared/contexts/Modal'
import { Button } from '@/shared/ui/Button'
import { ConfirmationModal } from '@/shared/ui/ConfirmationModal'


interface UserProfileFooterActionsProps {
  itsMe?: boolean
  onEditProfile: () => void
  onSignOut: () => void
  userUid: string
}

export const UserProfileFooterActions = ({
  itsMe,
  onEditProfile,
  onSignOut,
  userUid
}: UserProfileFooterActionsProps) => {
  const { openModal } = useModalContext()

  const handleSignOutClick = () => {
    openModal(
      {
        modal: ConfirmationModal
      },
      {
        title: 'Sair da conta',
        description: 'Tem certeza que deseja sair da sua conta?',
        onConfirm: onSignOut,
        confirmText: 'Sair',
        confirmButtonVariant: 'destructive'
      }
    )
  }

  if (itsMe)
    return (
      <div className="flex gap-4 w-full">
        <Button
          icon
          variant="destructive"
          className="flex-shink-0"
          onClick={handleSignOutClick}
          aria-label="Sair da conta"
        >
          <DoorOpen className="size-4" />
        </Button>
        <Button variant="primary" className="flex-grow-1" onClick={onEditProfile}>
          Editar Conta
        </Button>
      </div>
    )
  return <FollowUserButton className="w-full" userUid={userUid} />
}
